import React from "react";
import { useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import meat from "../assets/img/meat.svg";
import RestaurantLoader from "../utils/RestaurantLoader";

const CategoriesSection = (props) => {
  const { darkMode, color } = useSelector((state) => state.global);
  const { activeTab, setActiveTab, categories, categoriesLoading } = props;
  return (
    <Container className="categories">
      <div>
        <h4
          className={
            darkMode
              ? "fs--18 fw--600 normal-heading-dark"
              : "fs--18 fw--600 normal-heading"
          }
        >
          Categories
        </h4>
      </div>
      {categoriesLoading ? (
        <Row className="py-5 justify-content-center position-relative">
          {" "}
          <RestaurantLoader message="Fetching Menus Categories" />
        </Row>
      ) : (
        <Row className="d-flex flex-column categories__menu">
          <div className="mx-4 my-2 justify-content-center d-flex">
            {categories && categories?.length > 0 ? (
              <>
                <div
                  className="d-flex flex-nowrap overflow-auto px-2"
                  style={{ gap: "1.25rem" }}
                >
                  {categories.map((item) => {
                    const isActive = item?.id === activeTab?.id;
                    return (
                      <div
                        key={item.id}
                        onClick={() => setActiveTab(item)}
                        className={`d-flex flex-column align-items-center justify-content-center px-3 py-3 rounded cursor-pointer shadow-sm category-card ${
                          darkMode ? "bg-dark text-white" : "bg-white text-dark"
                        }`}
                        style={{
                          minWidth: "120px",
                          border: isActive
                            ? `2px solid ${color}`
                            : "1px solid #ddd",
                          transition: "all 0.3s ease",
                          boxShadow: isActive
                            ? `0 4px 12px ${color}66`
                            : "0 2px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <img
                          alt={item?.name}
                          src={item?.image || meat}
                          width={80}
                          height={80}
                          className="rounded mb-2 object-fit-cover"
                          style={{ objectFit: "cover" }}
                        />
                        <h6
                          className={`text-capitalize mb-0 text-center ${
                            isActive ? "fw-bold" : "fw-normal"
                          }`}
                          style={{ color: isActive ? color : undefined }}
                        >
                          {item?.name}
                        </h6>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <div className="fs--18 text-muted py-3">
                No Categories Added Yet
              </div>
            )}
          </div>
        </Row>
      )}
    </Container>
  );
};

export default CategoriesSection;
